import { MediaDevice } from '../types'

import { VIRTUAL_AUDIO_DEVICE_IDS } from './virtual-audio-device-ids'

/**
 * Chrome on Windows: getUserMedia({ deviceId: { exact: 'default' | 'communications' } })
 * often yields a live but silent track. Prefer the matching hardware id (same groupId).
 */
export const resolvePhysicalAudioDeviceId = (
  deviceId: string | undefined,
  knownDevices: Iterable<MediaDevice>,
): string | undefined => {
  if (!deviceId) {
    return undefined
  }

  if (!VIRTUAL_AUDIO_DEVICE_IDS.has(deviceId)) {
    return deviceId
  }

  const devices = Array.from(knownDevices)
  const virtualDevice = devices.find((device) => device.deviceId === deviceId)
  if (!virtualDevice?.groupId) {
    return undefined
  }

  return devices.find((device) => (
    !VIRTUAL_AUDIO_DEVICE_IDS.has(device.deviceId) && device.groupId === virtualDevice.groupId
  ))?.deviceId
}

export const getAudioInputConstraints = (
  deviceId: string | undefined,
  knownDevices: Iterable<MediaDevice>,
): boolean | MediaTrackConstraints => {
  const resolvedDeviceId = resolvePhysicalAudioDeviceId(deviceId, knownDevices)
  if (!resolvedDeviceId || VIRTUAL_AUDIO_DEVICE_IDS.has(resolvedDeviceId)) {
    return true
  }

  const hasDevice = Array.from(knownDevices).some((device) => device.deviceId === resolvedDeviceId)
  if (!hasDevice) {
    return true
  }

  return { deviceId: { exact: resolvedDeviceId }}
}
